import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  TemplateRef
} from '@angular/core';
import {
  DatasService,
  GetSubInstitutionsByPkGQL,
  Institutions,
  Institutions_Insert_Input
} from '@polylearn/models';
import { sortBy } from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, flatMap, map, tap } from 'rxjs/operators';
import { DialogService } from '../../../ui/dialog/dialog.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'apps/landing/src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdminService } from '../../../admin/admin.service';
import { formatDate } from '@angular/common';

import { AngularFireStorage } from '@angular/fire/storage';
import slugify from 'slugify';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'polylearn-institutions-list',
  templateUrl: './institutions-list.component.html',
  styleUrls: ['./institutions-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstitutionsListComponent implements OnInit {
  @Input() institutionId: number;

  institutions$: Observable<Institutions[]>;
  updateInstitutions$ = new BehaviorSubject(null);

  dataSource;

  displayedColumns: string[] = [
    'logo',
    'name',
    'used_credits',
    // 'credits',
    // 'total_credits',
    'actions'
  ];

  editOrgForm: FormGroup = this.fb.group({
    id: null,
    name: [null, [Validators.required]],
    logo: null,
    slug: null
  });

  actions = [
    {
      text: 'institutions.list.watch_organization',
      icon: 'change_circle',
      click: (element: Institutions) => {
        console.log('element', element);
        this.adminService.go(element.id, 'manager', true);
      }
    },
    {
      text: 'institutions.list.see_credits',
      icon: 'data_usage',
      click: (element: Institutions) => {
        const registrations = element.registrations;
        console.log('element', element);
        this.dialogService.alert(
          {
            title: this.translate.instant([
              'institutions_list.dialog.credits_usage'
            ])['institutions_list.dialog.credits_usage'],
            /*
            icon: {
              name: 'data_usage'
            },
            */
            matDialogConfig: {
              width: '100%'
            }
          },
          {
            text: registrations
              .map(
                r =>
                  `<b>${formatDate(r.created_at, 'shortDate', 'en')}: ${
                    r.level
                  }</b> ${r.email} par ${r.creator?.email}`
              )
              .join('<br>')
          }
        );
      }
    }
  ];

  constructor(
    private getSubInstitutionsByPkGQL: GetSubInstitutionsByPkGQL,
    private cd: ChangeDetectorRef,
    private dialogService: DialogService,
    private fb: FormBuilder,
    private dataService: DatasService,
    private _snackBar: MatSnackBar,
    private adminService: AdminService,
    private storage: AngularFireStorage,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.institutions$ = this.updateInstitutions$.pipe(
      flatMap(() => this.getInstitutions())
    );

    console.log('this.institutions$', this.institutionId);
  }

  public yolo() {
    console.log('yolo');
    window.alert('yolo');
  }

  private getInstitutions(): Observable<Institutions[]> {
    return this.getSubInstitutionsByPkGQL
      .fetch(
        {
          institutionPk: this.institutionId
        },
        {
          fetchPolicy: 'no-cache',
          context: {
            headers: {
              role: 'manager'
            }
          }
        }
      )
      .pipe(
        map(
          res =>
            (res.data.institutions_by_pk
              .subInstitutions as any) as Institutions[]
        )
      )
      .pipe(
        tap(res => {
          setTimeout(() => {
            this.dataSource = sortBy(res, 'name');
            this.cd.detectChanges();
          });
        })
      );
  }

  public async openAddOrgDialog(
    templateRef: TemplateRef<any>,
    org: Institutions = null
  ) {
    let title;

    let tr = this.translate.instant([
      'institutions_list.dialog.create',
      'institutions_list.dialog.edit',
      'institutions_list.dialog.created',
      'institutions_list.dialog.saved'
    ]);
    if (!org) {
      title = tr['institutions_list.dialog.create'];
      this.editOrgForm.patchValue({
        id: null,
        name: null,
        logo: null,
        slug: null,
        parent_institution_id: this.institutionId
      });
    } else {
      title = tr['institutions_list.dialog.edit'];
      this.editOrgForm.patchValue({
        id: org.id,
        name: org.name,
        logo: org.logo,
        slug: org.slug,
        parent_institution_id: org.parent_institution_id
      });
    }

    this.dialogService
      .custom(
        {
          title: title
        },
        {
          content: templateRef
        }
      )
      .subscribe(res => {
        console.log(res);
        if (res) {
          if (!org) {
            let exams = {};
            exams[environment.EXAM] = true;
            const insertOrg: Institutions_Insert_Input = {
              name: res.name,
              logo: res.logo || '',
              credits: 0,
              slug: res.slug || null,
              exams,
              parent_institution_id: this.institutionId
            };
            console.log('insertOrg', insertOrg);
            this.dataService
              .insertData$<Institutions>(
                'institutions',
                'manager',
                insertOrg as any,
                'id'
              )
              .subscribe(async r => {
                setTimeout(() => {
                  this.updateInstitutions$.next('update');
                }, 300);
                this._snackBar.open(
                  tr['institutions_list.dialog.created'],
                  null,
                  {
                    duration: 5000
                  }
                );
              });
          } else {
            this.dataService
              .updateData$<Institutions>(
                'institutions',
                'manager',
                org.id,
                {
                  name: res.name,
                  logo: res.logo || '',
                  slug: res.slug || null
                },
                'id'
              )
              .subscribe(async r => {
                setTimeout(() => {
                  this.updateInstitutions$.next('update');
                }, 300);
                this._snackBar.open(
                  tr['institutions_list.dialog.saved'],
                  null,
                  {
                    duration: 5000
                  }
                );
              });
          }
        }
      });
  }

  public getUrl() {
    let value = this.editOrgForm.value;

    if (!value.slug) {
      return null;
    }

    if (value.slug) {
      return `https://${window.location.hostname}/login?org=${value.slug}`;
    }
  }

  public uploadFile(event) {
    console.log('🔥');
    const file = event.target.files[0];
    if (file.size > 350000) {
      this._snackBar.open('Le fichier est trop lourd', null, {
        duration: 5000
      });
      return;
    }
    const filePath = `/institutions/${new Date().toISOString()}`;

    const fileRef = this.storage.ref(filePath);
    console.log('xxx');
    const task = this.storage.upload(filePath, file);
    console.log('xxx');
    let x = this._snackBar.open(`Logo en cours de téléchargement`, null, {});

    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          fileRef.getDownloadURL().subscribe(rr => {
            x.dismiss();
            console.log(rr);
            this.editOrgForm.patchValue({
              logo: rr
            });
          });
        })
      )
      .subscribe();
  }

  public generateSlug() {
    let value = this.editOrgForm.value;

    this.editOrgForm.patchValue({
      slug: slugify(value.name, {
        lower: true
      })
    });
  }

  public async exportInstitutionToExcel(institution: Institutions) {
    try {
      const XLSX = await import('xlsx');

      if (
        !institution.registrations ||
        institution.registrations.length === 0
      ) {
        this._snackBar.open(
          'Aucune licence à exporter pour cet établissement',
          null,
          {
            duration: 3000
          }
        );
        return;
      }

      // En-têtes simplifiées
      const headers = ['Établissement', 'Niveau', 'Date', 'Email', 'Créateur'];

      // Créer les lignes de données
      const rows: any[] = [headers];
      institution.registrations.forEach((reg: any) => {
        rows.push([
          institution.name,
          reg.level,
          new Date(reg.created_at).toLocaleDateString('fr-FR'),
          reg.email,
          reg.creator?.email || ''
        ]);
      });

      // Créer la feuille
      const ws = XLSX.utils.aoa_to_sheet(rows);
      ws['!cols'] = [
        { wch: 30 }, // Établissement
        { wch: 10 }, // Niveau
        { wch: 12 }, // Date
        { wch: 30 }, // Email
        { wch: 30 } // Créateur
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Données');

      const sanitizedName = institution.name
        .replace(/[^a-z0-9 ]/gi, '')
        .trim()
        .substring(0, 50);
      const timestamp = new Date().toISOString().split('T')[0];
      const filename = `${sanitizedName || 'institution'}-${timestamp}.xlsx`;

      XLSX.writeFile(wb, filename);

      this._snackBar.open('Export Excel réussi', null, {
        duration: 3000
      });
    } catch (error) {
      console.error("Erreur lors de l'export Excel:", error);
      this._snackBar.open("Erreur lors de l'export", null, {
        duration: 3000
      });
    }
  }

  public async exportAllToExcel() {
    try {
      const XLSX = await import('xlsx');

      if (!this.dataSource || this.dataSource.length === 0) {
        this._snackBar.open('Aucun sous-établissement à exporter', null, {
          duration: 3000
        });
        return;
      }

      // Collecter toutes les licences de tous les sous-établissements
      const allRegistrations: any[] = [];
      this.dataSource.forEach((institution: Institutions) => {
        if (institution.registrations && institution.registrations.length > 0) {
          institution.registrations.forEach((reg: any) => {
            allRegistrations.push({
              institutionName: institution.name,
              level: reg.level,
              created_at: reg.created_at,
              email: reg.email,
              creatorEmail: reg.creator?.email || ''
            });
          });
        }
      });

      if (allRegistrations.length === 0) {
        this._snackBar.open('Aucune licence à exporter', null, {
          duration: 3000
        });
        return;
      }

      // En-têtes
      const headers = ['Établissement', 'Niveau', 'Date', 'Email', 'Créateur'];

      // Créer les lignes de données
      const rows: any[] = [headers];
      allRegistrations.forEach(reg => {
        rows.push([
          reg.institutionName,
          reg.level,
          new Date(reg.created_at).toLocaleDateString('fr-FR'),
          reg.email,
          reg.creatorEmail
        ]);
      });

      // Créer la feuille
      const ws = XLSX.utils.aoa_to_sheet(rows);
      ws['!cols'] = [
        { wch: 30 }, // Établissement
        { wch: 10 }, // Niveau
        { wch: 12 }, // Date
        { wch: 30 }, // Email
        { wch: 30 } // Créateur
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Toutes les licences');

      const timestamp = new Date().toISOString().split('T')[0];
      const filename = `licences-sous-etablissements-${timestamp}.xlsx`;

      XLSX.writeFile(wb, filename);

      this._snackBar.open('Export Excel réussi', null, {
        duration: 3000
      });
    } catch (error) {
      console.error("Erreur lors de l'export Excel:", error);
      this._snackBar.open("Erreur lors de l'export", null, {
        duration: 3000
      });
    }
  }
}
